{
  "fr": {
    "form": {
      "actions": {
        "cancel": "Annuler",
        "closeFullPage": "Fermer la page",
        "copyText": "Cliquez pour copier le texte",
        "next": "Suivant",
        "openFullPage": "Ouvrir en pleine page",
        "save": "Sauvegardez",
        "saveChanges": "Sauvegardez les modifications",
        "send": "Envoyer",
        "send_and_create_another": "Envoyer et créer un autre",
        "submit": "Envoyer",
        "submit_and_create_another": "Soumettre et créer un autre"
      },
      "back": "Etape précédente",
      "notifications": {
        "textHasBeenCopied": "Le texte a été copié"
      },
      "password": "Mot de passe",
      "shortcuts": {
        "save_mac": "⌘ + Entrée pour sauvegarder",
        "save_windows": "Ctrl + Entrée pour enregistrer",
        "send_mac": "⌘ + Entrée pour envoyer",
        "send_windows": "Ctrl + Entrée pour envoyer"
      },
      "steps": "Etape {count} sur {total}",
      "writeEmployeeNameReject": "Noter <i><b>{employeeName}</b></i> pour terminer la suppression."
    }
  }
}